import { getHoursDiff } from '../utils'
import generateInvoicePdf from './generateInvoicePdf'

const columns = [
  {
    label: 'Route ID',
    field: 'routeId'
  },
  {
    label: 'Property Name',
    field: 'propNameAddress'
  },
  {
    label: 'Address',
    field: 'street'
  },
  {
    label: 'Date of Service Start',
    field: 'dateTimeStart'
  },
  {
    label: 'Date of Service End',
    field: 'dateTimeEnd'
  },
  {
    label: '% Service Complete',
    field: 'crewPercent'
  },
  {
    label: 'P, S, CW, DIW',
    field: 'code'
  },
  {
    label: '# Bags or Tons',
    field: 'quantityMaterial'
  },
  {
    label: '# Plows or Techs',
    field: 'plowsOrTechs'
  },
  {
    label: 'Total Man Hours',
    field: 'totalHours'
  },
  {
    label: 'Snow Depth',
    field: 'snowDepth'
  },
  {
    label: 'Notes',
    field: 'notes'
  },
]

export default function generateTimesheetPdf(data, vendor, timesheetId, shortNote, longNote, doc, lastPage, invoiceData) {
  const filteredData = data.filter(d => d.routeId !== '').map(d => {
    return {
      ...d,
      code: d.extraData?.Prod_CrewDesc,
      totalHours: Number(getHoursDiff(d.dateTimeStart, d.dateTimeEnd, d.plowsOrTechs).toFixed(2))
    }
  })

  function addTotals(data) {
    const grandTotal = {}
    for (const d of data) {
      const { totalHours, code } = d

      if (totalHours) {
        grandTotal[code]
          ? grandTotal[code] += totalHours
          : grandTotal[code] = totalHours
      }
    }

    grandTotal['Grand Total'] = Object.values(grandTotal).reduce((a, b) => a + b)

    for (const key of Object.keys(grandTotal)) {
      grandTotal[key] = grandTotal[key].toFixed(2)
    }
    return grandTotal
  }

  const totals = addTotals(filteredData)

  function getVendorStr() {
    return `${vendor} - Timesheet ID: ${timesheetId}${shortNote && ' - '}${shortNote}`
  }

  function flattenTotals(totals) {
    const emptyCount = 12 - Object.keys(totals).length * 2
    const rtnArr = []
    for (let i = 0; i < emptyCount; i++) {
      rtnArr.push(null)
    }
    return [...rtnArr, ...Object.entries(totals).flat()]
  }

  const vendorStr = getVendorStr()
  const flatTotals = flattenTotals(totals)

  const pdfFormat = {
    head: [[{ content: vendorStr, colSpan: columns.length }], columns.map(({ label }) => label)],
    body: filteredData.map(d => columns.map(({ field }) => d[field])),
    foot: [flatTotals],
    showFoot: 'lastPage',
    styles: {
      lineWidth: .1,
    },
    theme: 'plain',
    margin: [0, 0, 0, 0]
  }

  doc.autoTable(pdfFormat)

  if (!lastPage || longNote?.length || invoiceData) {
    doc.addPage()
  }

  if (invoiceData) {
    generateInvoicePdf(invoiceData, doc, lastPage && !longNote?.length)
  }

  if (longNote?.length) {
    const splitNote = doc.splitTextToSize(longNote, 180)
    doc.text(splitNote, 10, 10)
    if (!lastPage) {
      doc.addPage()
    }
  }
}